"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withdrawProductSelector = exports.whiteListedAddressesSelector = exports.productsListSelector = exports.productDepositLimitsSelector = exports.filteredWithdrawalsByProductSelector = exports.filteredDepositsByProductSelector = exports.depositProductSelector = exports.depositAddressSelector = void 0;
var _reselect = require("reselect");
var _reduxForm = require("redux-form");
var _instrumentPositionSelectors = require("./instrumentPositionSelectors");
var _orderHistoryFilters = require("../../helpers/orderHistoryFilters");
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formSelector = (0, _reduxForm.formValueSelector)('order-history-filter');
var products = function products(state) {
  return state.apexCore.product.products;
};
var depositProductId = function depositProductId(state) {
  return state.deposit.product;
};
var withdrawProductId = function withdrawProductId(state) {
  return state.withdraw.product;
};
var verificationLevelConfigsProducts = function verificationLevelConfigsProducts(state) {
  return (0, _get["default"])(state, ['user', 'verificationLevelConfigs', 'Products'], []);
};
var productsListSelector = exports.productsListSelector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.map(function (_ref) {
    var Product = _ref.Product,
      ProductFullName = _ref.ProductFullName,
      ProductId = _ref.ProductId,
      DecimalPlaces = _ref.DecimalPlaces;
    return {
      Product: Product,
      ProductFullName: ProductFullName,
      ProductId: ProductId,
      DecimalPlaces: DecimalPlaces
    };
  });
});
var filteredDepositsByProductSelector = exports.filteredDepositsByProductSelector = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, function (state) {
  return state.deposit.depositsStatus;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, deposits, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return deposits
    // .filter(
    //   deposit =>
    //     selectedProductId ? deposit.AssetId === selectedProductId : true
    // )
    .filter(function (deposit) {
      return (0, _orderHistoryFilters.dateFilter)(deposit, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return deposits
    // .filter(
    //   deposit =>
    //     deposit.AssetId === instrument.Product1 ||
    //     deposit.AssetId === instrument.Product2
    // )
    .sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});
var filteredWithdrawalsByProductSelector = exports.filteredWithdrawalsByProductSelector = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, function (state) {
  return state.withdraw.withdrawTickets;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return formSelector(state, 'startDate', 'endDate');
}, function (state, props) {
  return props.filterMode;
}], function (instrument, withdrawals, selectedProductId, formValues, filterMode) {
  if (filterMode === 'selectedProduct') {
    return withdrawals
    // .filter(
    //   withdrawal =>
    //     selectedProductId ? withdrawal.AssetId === selectedProductId : true
    // )
    .filter(function (withdrawal) {
      return (0, _orderHistoryFilters.dateFilter)(withdrawal, formValues.startDate, formValues.endDate, 'CreatedTimestamp');
    }).sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  } else {
    return withdrawals
    // .filter(
    //   withdrawal =>
    //     withdrawal.AssetId === instrument.Product1 ||
    //     withdrawal.AssetId === instrument.Product2
    // )
    .sort(function (a, b) {
      return new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp);
    });
  }
});
var depositProductSelector = exports.depositProductSelector = (0, _reselect.createSelector)([products, depositProductId], function (products, depositProductId) {
  return products.find(function (prod) {
    return prod.ProductId === depositProductId;
  });
});
var withdrawProductSelector = exports.withdrawProductSelector = (0, _reselect.createSelector)([products, withdrawProductId], function (products, withdrawProductId) {
  return products.find(function (prod) {
    return prod.ProductId === withdrawProductId;
  });
});
var depositAddressSelector = exports.depositAddressSelector = (0, _reselect.createSelector)(function (state) {
  return state.deposit;
}, function (deposit) {
  var addressList = deposit.depositInfo,
    isLoading = deposit.isLoading;
  var selectedAddress;
  if (!isLoading && addressList.length) {
    selectedAddress = addressList[addressList.length - 1];
  }
  return selectedAddress;
});
var whiteListedAddressesSelector = exports.whiteListedAddressesSelector = (0, _reselect.createSelector)(function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}, function (state) {
  return state.eotcWithdraw.withdrawInfos;
}, function (selectedAccountId, selectedProductId, withdrawInfos) {
  return withdrawInfos.filter(function (_ref2) {
    var AccountId = _ref2.AccountId,
      ProductId = _ref2.ProductId;
    return AccountId === selectedAccountId && ProductId === selectedProductId;
  });
});
var productDepositLimitsSelector = exports.productDepositLimitsSelector = (0, _reselect.createSelector)([products, depositProductId, verificationLevelConfigsProducts], function (products, depositProductId, verificationLevelConfigsProducts) {
  var product = products.find(function (prod) {
    return prod.ProductId === depositProductId;
  });
  var verificationLevelConfigsProduct = product && verificationLevelConfigsProducts.find(function (VerificationLevelConfigsProduct) {
    return VerificationLevelConfigsProduct.ProductId === product.ProductId;
  });
  return verificationLevelConfigsProduct;
});